<template>
    <div>
      <div v-if="rechargeing" style="text-align: center">
        <div v-if="rechargeing" id="qrcode" ref="qrcode" style="width: 150px;height: 150px;margin: 0 auto"></div>
        <p style="color: red;font-size: 28px;padding-top: 30px;">{{feeNum}}元</p>
        <p style="color: #A5A5Af;font-size: 20px;padding-top: 30px;">请使用微信扫一扫完成支付</p>
      </div>
      <div v-else class="payresult-bg">
        <div class="payresult-top">

        </div>
        <div class="payresult">
          <img src="../../assets/pay/pay_success.png" width="60" height="60">
          <span class="pay-text">充值完成</span>
        </div>
      </div>
    </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  export default {
    name: 'WeChatQRCode',
    props: {
      rqcodeUrl: {
        required: false
      },
      ordernum: {
        required: false
      },
      feeNum: {
        required: false
      }
    },
    data () {
      return {
        rechargeing : true
      }
    },
    methods: {
      initQRCode () {
        this.$nextTick(()=>{
          this.createQrcode()
        })
        this.selectRechargeSuccess()
      },
      closeRqCode () {
        this.$refs.qrcode.innerHTML = ''
      },
      createQrcode () {
        var that = this
        this.qrcode = new QRCode('qrcode', {
          width: 150,
          height: 150,
          text: that.rqcodeUrl,
          colorDark: '#000',
          colorLight: '#fff'
        })
      },
      selectRechargeSuccess () {
        let requestData = {trade_no:this.ordernum}
        this.$api.recharge.queryWxChatResult(requestData).then((res) => {
          if (res.code === 0) {
            this.rechargeing = false
            this.closeRqCode()
          }else{
            setTimeout(this.selectRechargeSuccess,3000)
            // this.rechargeing = false
            // this.closeRqCode()
          }

        })
      }
    }
  }

</script>

<style scoped>
  .payresult-bg{
    width: 100%;
    height: 100%;
  }
  .payresult-top{
    height: 50px;
  }
  .payresult{
    padding: 20px;
    width: 300px;
    background-color: #ffffff;
    margin:0 auto 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .pay-text{
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/page/financedManager/WeChatQRCode.vue